import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FeedbackRoundStatus } from '@brafton/feedback-api';

/** The selectable filter value: a specific status, or `all`. */
export type StatusFilterValue = FeedbackRoundStatus | 'all';

interface StatusFilterOption {
  value: StatusFilterValue;
  label: string;
}

const STATUS_FILTER_OPTIONS: readonly StatusFilterOption[] = [
  { value: 'all', label: 'All' },
  { value: FeedbackRoundStatus.Open, label: 'Open' },
  { value: FeedbackRoundStatus.Completed, label: 'Completed' },
  { value: FeedbackRoundStatus.Closed, label: 'Closed' },
  { value: FeedbackRoundStatus.Cancelled, label: 'Cancelled' },
];

/**
 * Status filter chips for the Projects listing: All / Open / Completed /
 * Closed / Cancelled. The selected chip is filled — the accent color for
 * `All`, or the status's own color for a specific status.
 */
@Component({
  selector: 'app-status-filter',
  templateUrl: './status-filter.html',
  styleUrl: './status-filter.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusFilter {
  /** The currently-selected filter value. */
  readonly selected = input<StatusFilterValue>('all');

  /** Emits the chosen filter value when a chip is clicked. */
  readonly selectedChange = output<StatusFilterValue>();

  protected readonly options = STATUS_FILTER_OPTIONS;

  protected select(value: StatusFilterValue): void {
    if (value !== this.selected()) {
      this.selectedChange.emit(value);
    }
  }
}
